import React, { useState, useEffect, useRef } from "react";
import {
  Button,
} from "react-bootstrap";
import { colors } from "../configs";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate , Outlet, NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout, signin, signin_customToken } from '../redux/authSlice';
import { shopchamAPI } from "../Utility/api";
import { Modal_LoginByEmail, Modal_LoginByScan, Modal_Splash } from "../modal";
import { fetchNormalProfile } from "../redux/profileSlice";
import { fetchNormalShop } from "../redux/shopSlice";
import { db, firebaseAuth } from "../db/firestore";

const { white } = colors;
const anynonymous  = [
  "owner@gmail.com", "owner2@gmail.com", "owner3@gmail.com", 
  "owner4@gmail.com", "owner5@gmail.com", "owner6@gmail.com", 
  "owner7@gmail.com", "owner8@gmail.com", "owner9@gmail.com", 
  "owner10@gmail.com", 
];

function HomeScreen() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { currentUser, currentShopId } = useSelector((state)=> state.auth)

    const [formData, setFormData] = useState({email:'',password:''})
    const [loading, setLoading] = useState(true);
    const [email_Modal, setEmail_Modal] = useState(false);

    const handleFormChange = (event) => {
      event.preventDefault();

      const fieldName = event.target.getAttribute("name");
      const fieldValue = event.target.value;
      const newFormData = { ...formData };

      switch (fieldName) {
        default:
          newFormData[fieldName] = fieldValue; // dynamic object referent  (eg. equal 'obj.price')
      }

      setFormData(newFormData);
    };

    useEffect(()=>{
        if(currentUser?.user?.uid && !anynonymous.includes(currentUser?.user?.email)){
          handleProfile(currentUser?.user?.uid)
        } else {
          setLoading(false)
        }
        
    },[])

    const checkRegisterUser = async() => {
      setEmail_Modal(false)
      setLoading(true)
      
      try {
        const { status,data } = await shopchamAPI.post(
          "/users/email/",
          {
            email:formData?.email.trim(), 
          }
        
        );
        if(status === 200){
          const { uid } = data;
          const user = await dispatch(signin(formData))
          if(user.payload){
            handleProfile(uid)
          } else {
            setLoading(false)
          }
        } else {
          setLoading(false)
        }
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    };

    async function handleProfile(profileDoc){
        let shopData = {};
        let path = 'shoplist';
        try {
          const profileData = await db.collection('profile').doc(profileDoc).get();
          if(!profileData.exists){
            alert('ไม่พบบัญชี ผู้ใช้งาน')
            dispatch(logout())
            return;
          };
          let loginByShopId = ''
          const { port, currentLogin } = profileData.data();
          const lastLogin = port.find(a=>a.shopId === currentShopId);

          if(lastLogin){
            loginByShopId = currentShopId

          } else if(currentLogin && currentLogin.shopId){
            loginByShopId = currentLogin.shopId

          }
          
          if(loginByShopId){
              const qsnapshot = await db.collection('shop').where('shopId','==',loginByShopId).get();
              qsnapshot.docs.forEach((doc)=>{
                shopData = {...doc.data(), id:doc.id}
              })
              const { humanResource = [] } = shopData;
              if(humanResource.some(a=>a.id===profileDoc && (a.rights?.includes('107') || a.owner || a?.position?.includes('001') ))){
                path = "/master"
              } 
          } 
          setLoading(false)
          dispatch(fetchNormalShop(shopData));
          dispatch(fetchNormalProfile({...profileData.data(),id:profileDoc}));
          navigate(path)
        } catch (error) {
          console.log(error)
        }
    };

    //************************LoginByScan****************************** */
    const unsubscribeRef = useRef(null);
    const [docId, setDocId] = useState('');
    const [scan_Modal, setScan_Modal] = useState(false);

    const startListener = async (docId) => {
      console.log("Starting Firestore listener...");

      unsubscribeRef.current = db.collection("loginByScan")
        .where('docId','==',docId)
        .onSnapshot(
          { includeQueryMetadataChanges: true },
          async (snapshot) => {
            snapshot.docChanges().forEach( async (change) => {
              if (change.type === "modified") {
                const { uid } = change.doc.data();
                if (uid) {
                  console.log("UID received, logging in...", uid);
                  await testLogin(uid);
                  closeScan(docId);
                }
              }
            });
          },
          (error) => {
            console.error("Firestore listener error:", error);
          }
        );
    };

    const stopListener = () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
        unsubscribeRef.current = null;
        console.log("Firestore listener stopped.");
      }
    };

    const openScan = async () => {
      setLoading(true)
      try {
        await firebaseAuth.signInWithEmailAndPassword(anynonymous[Math.floor(Math.random() * anynonymous.length)], '123456')
        const scanRef = db.collection("loginByScan").doc();
        await scanRef.set({ uid: "", docId:scanRef.id, timestamp:new Date() });
        setLoading(false)
        setScan_Modal(true)
        startListener(scanRef.id);
        setDocId(scanRef.id)
        
      } catch (error) {
        console.error("Error creating login:", error);
      }
    };

    function closeScan(docId){
      setScan_Modal(false)
      stopListener();
      db.collection('loginByScan').doc(docId).delete()
    };

    const testLogin = async (uid) => {
      try {
        const { status, data } = await shopchamAPI.post("/users/scan/", { uid });

        if (status === 200) {
          const { frbUserCustomToken } = data;
          const user = await dispatch(signin_customToken(frbUserCustomToken));
          console.log("User authenticated successfully.");
          if(user.payload){
            handleProfile(uid)
          } else {
            setLoading(false)
          }
        }
      } catch (error) {
        console.log(error)
        alert("Error during login:", error);
      }
    };


  return (
    <div  style={styles.container} >
        <Modal_LoginByScan
            show={scan_Modal}
            onHide={()=>{closeScan(docId)}}
            docId={docId}
        />
        <Modal_LoginByEmail
            show={email_Modal}
            onHide={()=>{setEmail_Modal(false)}}
            formData={formData}
            handleFormChange={handleFormChange}
            onClick={checkRegisterUser}
        />
        <div style={styles.container2} >
            <h3>เลือกวิธีเข้าใช้งาน</h3>
            <Button onClick={openScan} variant="warning" style={styles.container3} >
                <h4>1. เข้าใช้งานด้วยการสแกน QR Code</h4>
            </Button>
            <h3>หรือ</h3>
            <Button onClick={()=>{setEmail_Modal(true)}} variant="warning" style={styles.container3} >
              <h4>2. เข้าใช้งานด้วยอีเมล</h4>
            </Button>
        </div>
    </div>
  );
};

const styles = {
  container : {
    width: "100%",
    height: "100vh", // Full viewport height
    backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/shopcham-24b0b.appspot.com/o/owner%2Fshopchamp_background_with_logo.png?alt=media&token=4cb0cdba-57a9-4de0-9fbe-71d8b41ee760')",
    backgroundSize: "cover", // Ensures the image covers the entire div
    backgroundPosition: "center", // Centers the image
    backgroundRepeat: "no-repeat", // Prevents image from repeating
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
  },
  container2 : {
    backgroundColor:white,
    borderRadius:50,
    padding:20,
    paddingTop:5,
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    width:'25%',
    minWidth:'300px',
    opacity:0.9,
    marginTop:100
  },
  container3 : {
    width:'100%',
    borderRadius:20,
    marginTop:10,
    paddingTop:30,
    paddingBottom:30, 
    marginBottom:10
  },
}

export default HomeScreen;
